import(/* webpackMode: "eager", webpackExports: ["Providers"] */ "/app/src/redux/provider.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/styles/globals.css");
;
import(/* webpackMode: "eager" */ "/app/src/app/fonts.css");
